export const routeContainsVerb = (location, routes) => (
  location ?
    routes.some(route => {
      const segments = location.pathname.split('/')

      return segments.some(segment => segment === route)
    }) :
    false
)
